import iconsConfig from './icons-config/icons-config'
import colors from './themes'
import { rgbToken } from '@/services/theme/css-tokens'
import { defineVuesticConfig } from 'vuestic-ui'

export default defineVuesticConfig({
  devtools: false,
  colors,
  icons: iconsConfig,
  breakpoint: {
    enabled: true,
    bodyClass: true,
    thresholds: {
      xs: 0,
      sm: 320,
      md: 640,
      lg: 1024,
      xl: 1440,
    },
  },
  components: {
    VaButton: {
      hoverMaskColor: rgbToken('--c-primary-hover-rgb', '35, 40, 88'),
      hoverOpacity: 1,
    },
    VaIcon: {
      sizesConfig: {
        defaultSize: 19,
        sizes: {
          small: 14,
          medium: 19,
          large: 26,
        },
      },
    },
    VaModal: {
      mobileFullscreen: false,
      maxHeight: 'calc(100% - 2rem)',
    },
    VaPagination: {
      activeButtonProps: {
        preset: 'primary',
      },
    },
    VaPopover: {
      color: rgbToken('--c-tooltip-bg-rgb', '44, 49, 112'),
    },
    VaDataTable: {
      disableClientSideSorting: true,
    },
    presets: {
      VaButton: {
        danger: {
          class: 'va-button--danger',
          color: 'danger',
          hoverMaskColor: rgbToken('--c-danger-hover-rgb', '124, 39, 57'),
          hoverOpacity: 1,
          pressedMaskColor: rgbToken('--c-danger-pressed-rgb', '110, 30, 21'),
          pressedOpacity: 1,
        },
      },
      VaSelect: {
        small: {
          class: 'va-select--small',
          keepAnchorWidth: false,
          placement: 'bottom-end',
          width: 'min(100%, 150px)',
          style:
            '--va-input-wrapper-min-height: 24px; --va-input-wrapper-border-radius: 2px; --va-input-wrapper-width: 100px;',
        },
      },
    },
  },
})
